import * as React from 'react';
const SvgShareArrow = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 16 15" fill="none" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.9 10.56l4.417-3.555L8.9 3.463v1.936l-1.326.42C5.292 6.542 3.936 8.146 3.1 9.917c-.07.147-.135.293-.196.44a13.59 13.59 0 013.71-1.385L8.9 8.496v2.064zm-3.8.855c.595-.242 1.23-.444 1.9-.583v2.13c0 .63.73.98 1.22.584l7.403-5.958a.75.75 0 00-.001-1.17L8.219.482A.75.75 0 007 1.066v2.942C2.658 5.384 1.01 9.283.383 12.046a16.388 16.388 0 00-.352 2.315c-.017.222.257.329.415.172l.134-.13a15.316 15.316 0 011.525-1.286A13.86 13.86 0 015.1 11.415z"
            fill="currentColor"
        />
    </svg>
);
export default SvgShareArrow;
